import React from 'react';

const ReportRadarChart = ({ data, size = 220 }) => {
    if (!data || data.length === 0) return null;
    
    const center = size / 2;
    const maxRadius = (size / 2) - 30;
    const levels = 4;
    const angleStep = (2 * Math.PI) / data.length;

    const getPoint = (value, index, radius) => {
        const angle = angleStep * index - Math.PI / 2;
        const r = (value / 100) * radius;
        return {
            x: center + r * Math.cos(angle),
            y: center + r * Math.sin(angle)
        };
    };

    const levelPaths = Array.from({ length: levels }, (_, i) => {
        const radius = maxRadius * ((i + 1) / levels);
        const points = data.map((_, index) => getPoint(100, index, radius));
        return points.map(p => `${p.x},${p.y}`).join(' ');
    });

    const dataPoints = data.map((item, index) => getPoint(item.value, index, maxRadius));
    const dataPath = dataPoints.map(p => `${p.x},${p.y}`).join(' ');

    return (
        <div className="flex flex-col items-center justify-center w-full h-full">
            <div className="relative" style={{ width: size, height: size }}>
                <svg width={size} height={size} className="overflow-visible">
                    {/* Level Polygons */}
                    {levelPaths.map((path, i) => (
                        <polygon
                            key={i}
                            points={path}
                            fill="none"
                            stroke="#F1F5F9"
                            strokeWidth="1.5"
                        />
                    ))}

                    {/* Axis Lines */}
                    {data.map((_, index) => {
                        const endPoint = getPoint(100, index, maxRadius);
                        return (
                            <line
                                key={index}
                                x1={center}
                                y1={center}
                                x2={endPoint.x}
                                y2={endPoint.y}
                                stroke="#F1F5F9"
                                strokeWidth="1.5"
                            />
                        );
                    })}

                    {/* Data Polygon */}
                    <polygon
                        points={dataPath}
                        fill="#D1FAE5"
                        fillOpacity="0.8"
                        stroke="#10E58F"
                        strokeWidth="3"
                        strokeLinejoin="round"
                        className="transition-all duration-1000 ease-out"
                    />

                    {/* Labels */}
                    {data.map((item, index) => {
                        const labelPoint = getPoint(100, index, maxRadius + 20);
                        let textAnchor = "middle";
                        if (labelPoint.x < center - 15) textAnchor = "end";
                        if (labelPoint.x > center + 15) textAnchor = "start";
                        
                        return (
                            <text
                                key={index}
                                x={labelPoint.x}
                                y={labelPoint.y}
                                textAnchor={textAnchor}
                                dominantBaseline="middle"
                                className="text-[8px] font-extrabold fill-slate-500tracking-widest"
                            >
                                {item.label}
                            </text>
                        );
                    })}
                </svg>
            </div>
        </div>
    );
};

export default ReportRadarChart;
